webpackJsonp([17],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(40);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _agreement = __webpack_require__(225);
	
	var _agreement2 = _interopRequireDefault(_agreement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	new _vue2.default({
	  el: '#app',
	  template: '<agreement/>',
	  components: { agreement: _agreement2.default }
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var apiLinks = void 0;
	
	var yc = 'https://yc.yonyoucloud.com';
	
	var enterpriseId = 51430;
	
	var tenantid = 'lcplqaf2';
	
	var slogan = '';
	var logourl = 'static/imgs/logo.png';
	
	var companyname = '奥德集团';
	var companyfullname = '奥德集团';
	
	var companyHomePage = 'http://www.odc.hk';
	
	var companyContactUs = 'http://www.aotecar.com/contact/&columnsId=55&FrontColumns_navigation01-1404201334910345678FirstColumnId=55.html';
	
	var portaltype = 'odc';
	
	var bannerList = [{
	  class: 'carousel-bg-jsqp2'
	}];
	
	var telephone = '0539-8389170';
	var address = '山东省临沂市河东区北京路东路6666号';
	var servicetime = '周一至周五 上午08:30至下午17:30';
	
	exports.apiLinks = apiLinks = {
	  logourl: logourl,
	  address: address,
	  companyfullname: companyfullname,
	  telephone: telephone,
	  servicetime: servicetime,
	  companyname: companyname,
	  context: portaltype,
	  bannerList: bannerList,
	  slogan: slogan,
	  companyContactUs: companyContactUs,
	  selfHome: companyHomePage,
	  welcome: '你好，欢迎来到' + companyname + '采购门户！',
	  portaltype: portaltype,
	
	  materiaClass: yc + '/yuncai/jsonp/getMaterialClass?enterpriseId=' + enterpriseId + '&parentId=',
	  orgClass: yc + '/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' + enterpriseId,
	  southCement: {
	    home: companyHomePage
	  },
	  caslogout: '/yuncai/caslogout',
	
	  register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=' + portaltype,
	
	  enterWorkbench: yc + '/workbench/sso/login.jsp',
	
	  suppliersFor: yc + "/cpu-portal-fe/portalcas.html#/pages/supplymgr/addSupplyApply?purentid=" + enterpriseId + "&ipuid=" + portaltype + "&v=" + Date.parse(new Date().toLocaleDateString()),
	
	  infoTable: {
	    latest: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'latest2', 'latest3'],
	    area: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'area2', 'area3', 'area4', 'area5', 'area6', 'area7', 'area8'],
	    type: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', '2', '3', '4']
	  },
	
	  purchasetableDate: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=10&pageSize=10&pageIndex=0', '', ''],
	
	  logisticstableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0', '', ''],
	
	  logisticsestableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=11&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=13&pageSize=10&pageIndex=0'],
	
	  engineeringtableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=12&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=14&pageSize=10&pageIndex=0'],
	
	  details: {
	    bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
	    bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
	    bidNotice: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
	    bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
	    bidMsg2: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
	
	    bidMsg3: yc + '/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id=',
	    inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
	    company: yc + '/gwmanage/pages/notice/detail.html?id=',
	    noticeMore: yc + '/cpu-dashboard-fe/index.html#/anoucementlist?tenantid=' + tenantid,
	    lbnoticeMore: yc + '/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=' + enterpriseId + '&status=18',
	    cqnoticeMore: yc + '/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=' + enterpriseId + '&status=19',
	    lbNotice: yc + '/cpu-fe-bid/dist/lbnotice/index.html?id=',
	    cqNotice: yc + '/cpu-fe-bid/dist/clarifynotice/index.html?id=' },
	  notice: {
	    company: '/gwmanage/pub/notice/entnotice?tenantid=' + tenantid + '&pageIndex=1&pageSize=6&key=',
	    bidding: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageSize=6&pageIndex=0',
	    clarify: '',
	    lbnotice: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=18&pageIndex=0&pageSize=6',
	    cqnotice: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=19&pageIndex=0&pageSize=6'
	  },
	
	  contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId,
	
	  agreement: yc + '/cpu-supplymgr/supplyApply/isExistApply?purEntId=' + enterpriseId
	};
	exports.apiLinks = apiLinks;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(2);
	
	exports.default = {
	  name: 'gheader',
	  props: {
	    type: ''
	  },
	  data: function data() {
	    return {
	      southCement: _links.apiLinks.southCement['home'],
	      enterWorkbench: _links.apiLinks.enterWorkbench,
	      caslogout: _links.apiLinks.caslogout,
	      apiLinks: _links.apiLinks
	    };
	  }
	};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(2);
	
	exports.default = {
	  data: function data() {
	    return {
	      slogan: _links.apiLinks.slogan,
	      logourl: _links.apiLinks.logourl
	    };
	  }
	};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(2);
	
	exports.default = {
	  name: 'grednav',
	  props: {
	    type: ''
	  },
	  data: function data() {
	    return {
	      apiLinks: _links.apiLinks
	    };
	  }
	};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(13)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(8),
	  /* template */
	  __webpack_require__(19),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(11)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(17),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(12)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(10),
	  /* template */
	  __webpack_require__(18),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-logo"
	  }, [_c('div', {
	    staticClass: "main-width set-position"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.logourl,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "inline-block",
	      "position": "relative",
	      "top": "10px",
	      "font-size": "18px"
	    }
	  }, [_vm._v(_vm._s(_vm.slogan))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "apps"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/wechat.jpg",
	      "alt": "",
	      "width": "70px"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("友云采公众号")]), _vm._v(" "), _c('img', {
	    staticClass: "hideimg",
	    attrs: {
	      "src": "static/imgs/supplier.png",
	      "alt": "",
	      "width": "70px"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "hideimg"
	  }, [_vm._v("供应商App")]), _vm._v(" "), _c('img', {
	    staticClass: "hideimg",
	    attrs: {
	      "src": "static/imgs/purchaser.png",
	      "alt": "",
	      "width": "70px"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "hideimg"
	  }, [_vm._v("采购商App")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-group pull-right hidden"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "搜索商机/物资"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/search.png"
	    }
	  })])])])
	}]}

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-red-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('ul', {
	    staticClass: "list-basic-settings",
	    attrs: {
	      "id": "red-nav-navbar"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": _vm.apiLinks.selfHome,
	      "target": "_blank"
	    }
	  }, [_vm._v("返回官网")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "purchase.html"
	    }
	  }, [_vm._v("招采信息")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "target": "_blank",
	      "href": "contact.html"
	    }
	  }, [_vm._v("联系我们")])])
	}]}

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "row-nav-navbar"
	    }
	  }, [_c('ul', {
	    staticClass: "list-basic-settings pull-right"
	  }, [(_vm.type == 'home') ? [_vm._m(0)] : [_vm._m(1)], _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.enterWorkbench
	    }
	  }, [_vm._v("工作中心")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
	    staticClass: "home-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.apiLinks.selfHome,
	      "target": "_blank"
	    }
	  }, [_vm._v("返回官网")])]), _vm._v(" "), _c('li', {
	    staticClass: "cashome-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.apiLinks.selfHome,
	      "target": "_blank"
	    }
	  }, [_vm._v("返回官网")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
	    staticClass: "cashome-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.caslogout
	    }
	  }, [_vm._v("退出")])])], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   |  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "cashome.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   |  ")])
	}]}

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GHeader = __webpack_require__(14);
	
	var _GHeader2 = _interopRequireDefault(_GHeader);
	
	var _GLogo = __webpack_require__(15);
	
	var _GLogo2 = _interopRequireDefault(_GLogo);
	
	var _GRednav = __webpack_require__(16);
	
	var _GRednav2 = _interopRequireDefault(_GRednav);
	
	var _links = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    gheader: _GHeader2.default,
	    glogo: _GLogo2.default,
	    grednav: _GRednav2.default
	  },
	  data: function data() {
	    return {
	      companyName: _links.apiLinks.companyname
	    };
	  },
	
	  methods: {
	    enterlink: function enterlink() {
	      var str = window.location.href;
	      var array = str.split('?');
	      if (array[1] === 'register') {
	        window.location.href = _links.apiLinks.register;
	      } else if (array[1] === 'applyFor') {
	        window.location.href = _links.apiLinks.suppliersFor;
	      }
	    }
	  }
	};

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(213)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(151),
	  /* template */
	  __webpack_require__(254),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('gheader', {
	    attrs: {
	      "type": "home"
	    }
	  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav', {
	    attrs: {
	      "type": "home"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-agreement"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "agreement"
	    }
	  }, [_c('h2', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("采购门户注册协议")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('p', [_vm._v("注册用户协议："), _c('br'), _vm._v("\n            欢迎来到" + _vm._s(_vm.companyName) + "采购门户，如您确定成为本网用户，必须遵守本协议，如表示同意，您即与" + _vm._s(_vm.companyName) + "签定入网协议，并受本协议约束，请仔细审阅。")]), _vm._v(" "), _c('p', [_vm._v("一、注册须知。"), _c('br'), _vm._v("\n            1、申请参加" + _vm._s(_vm.companyName) + "采购活动的供应商，必须在" + _vm._s(_vm.companyName) + "电子采购平台上进行注册登记，并应具备以下条件："), _c('br'), _vm._v("\n            （1）依法成立，具有独立承担民事责任的能力，具有法人资格或得到企业法人的授权；"), _c('br'), _vm._v("\n            （2）具有良好的商业信誉和健全的财务会计制度；"), _c('br'), _vm._v("\n            （3）具有履行合同所必备的能力和信誉；"), _c('br'), _vm._v("\n            （4）具有与所供应的产品相适应的销售资质，如非生产厂家，需有所销售产品生产厂家的经销授权；"), _c('br'), _vm._v("\n            （5）近三年经营活动中无违法、违规记录和重大法律纠纷；"), _c('br'), _vm._v("\n            （6）提供的产品必须符合国家质量标准,取得相应的质量认证；"), _c('br'), _vm._v("\n            （7）项目要求的其他必备条件。"), _c('br'), _vm._v("\n            2、本平台目前不收服务费用，一旦本平台发出公告决定收费，注册用户必须根据本平台的相关规定按时足额交纳服务费用，否则将不能继续使用本平台。"), _c('br'), _vm._v("\n            3、供应商应承诺网上注册登记的全部信息和注册入库后所登记、变更的信息，以及为注册登记所提供的一切附件资料合法、真实、准确和有效，并依法、诚信参与" + _vm._s(_vm.companyName) + "采购活动，如有弄虚作假或其他违法违规行为，将取消其平台注册资格并按政府采购法相关法律法规规定作出相关处罚。\n          ")]), _vm._v(" "), _c('p', [_vm._v("二、用户的权利与责任。"), _c('br'), _vm._v("\n            1、权利"), _c('br'), _vm._v("\n            （1）您可以在本网站上传资质文件和下载标书、查看所投标项目的相关信息，并进行投标、竞价。"), _c('br'), _vm._v("\n            （2）如您发现在本网站上有操作或质疑的问题，有查询和澄清的权利。"), _c('br'), _vm._v("\n            （3）有权对" + _vm._s(_vm.companyName) + "相关业务及人员进行投诉，欢迎您进行监督。"), _c('br'), _vm._v("\n            2、责任"), _c('br'), _vm._v("\n            （1）必须保证所提供资质的真实性和准确性。如提供虚假信息，将被永久取消给" + _vm._s(_vm.companyName) + "平台采购商供货或竞买资格，并承担由此造成的后果。"), _c('br'), _vm._v("\n            （2）中标单位必须在规定期限内签订并履行合同。"), _c('br'), _vm._v("\n            （3）不得将登录帐号转给其他单位或个人使用，否则，您将承担因此给造成的后果。"), _c('br'), _vm._v("\n            （4）不利用登录帐号对本网站非法登录或进行数据破坏活动。"), _c('br'), _vm._v("\n            （5）如果您的用户名和密码因保管不善丢失或泄露，应立即书面通知" + _vm._s(_vm.companyName) + "服务人员，申请停用；否则，由此引起的后果，由您承担。停止使用期间，将无法进行业务；如需要继续进行业务，须重新设置用户名和密码，并将您的承诺书书面提交" + _vm._s(_vm.companyName) + "服务人员，" + _vm._s(_vm.companyName) + "服务人员可重新给予开通业务。\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            三、与" + _vm._s(_vm.companyName) + "开展业务的办事程序："), _c('br'), _vm._v("\n            （1）新单位注册，在网上提交您的相关资质，" + _vm._s(_vm.companyName) + "审核通过后，可参与" + _vm._s(_vm.companyName) + "采购门户后续业务。"), _c('br'), _vm._v("\n            （2）可在电子采购交易平台上完成标书下载或获取竞价信息。"), _c('br'), _vm._v("\n            （3）网上投标或竞价。"), _c('br'), _vm._v("\n            （4）招标方组织网上开标。"), _c('br'), _vm._v("\n            （5）招标方在网上发布中标公告。"), _c('br'), _vm._v("\n            （6）签定并执行合同。\n          ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "continue"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-info",
	    on: {
	      "click": function($event) {
	        _vm.enterlink()
	      }
	    }
	  }, [_vm._v("同意并继续")])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "source"
	    }
	  }, [_c('p')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n            四、本网站的权利与责任"), _c('br'), _vm._v("\n            1、权利"), _c('br'), _vm._v("\n            （1）当用户违反相关法律法规或本协议规定，以及本公司规章制度时，本网站有权取消其信息的发布或入网权限，直至追究法律责任。"), _c('br'), _vm._v("\n            （2）当网站出现安全方面的紧急状况时，本网站有权短时间暂停服务。"), _c('br'), _vm._v("\n            2、责任"), _c('br'), _vm._v("\n            （1）本网站有责任保证信息的准确性。"), _c('br'), _vm._v("\n            （2）本网站有责任保证信息的安全性。"), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n            五、适用法律、法规"), _c('br'), _vm._v("\n            1、《中华人民共和国公安部计算机安全法》"), _c('br'), _vm._v("\n            2、《中华人民共和国招投标法》"), _c('br'), _vm._v("\n            3、《中华人民共和国合同法》"), _c('br'), _vm._v("\n            4、《招标公告发布暂行办法》"), _c('br'), _vm._v("\n            5、《评标委员会和评标方法暂行规定》"), _c('br'), _vm._v("\n            6、《中华人民共和国政府采购法实施条例》\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n            六、免责声明"), _c('br'), _vm._v("\n            以下情况本网站声明免责："), _c('br'), _vm._v("\n            1、本网已经采取合理的防电脑病毒手段，但仍遭受电脑病毒破坏的致使用户资料受损，以及产生的后果不承担任何责任。"), _c('br'), _vm._v("\n            2、本网已经采取合理的防电脑黑客入侵手段，但仍遭受电脑黑客入侵致使用户资料受损或被窃取，以及产生的后果不承担任何责任。"), _c('br'), _vm._v("\n            3、因计算机设施或操作系统软件本身固有的技术缺陷而引起的用户资料数据受损或被窃取，以及产生的后果不承担任何责任。"), _c('br'), _vm._v("\n            4、无法预见、无法避免且无法克服的其它不可抗情况，本网站不承担任何责任。"), _c('br'), _vm._v("\n            5、本网站对任何因用户不正当或非法使用服务，及用户发布言论、信息而产生的直接、间接、偶然、特殊及后续的损害不承担任何责任。"), _c('br'), _vm._v("\n            6、本网站对因第4条规定的不可抗力原因造成的服务中断或不能满足用户的要求及产生后果不承担任何责任。"), _c('br'), _vm._v("\n            7、由于通信线路、网络、用户所在位置以及其它任何技术原因导致用户不能接受本网服务时，本网站不承担任何责任。"), _c('br'), _vm._v("\n            8、对于因注册用户提交资料不准确或不及时更新其资料而给他人或自己造成的任何损失、影响及风险，本网站不承担任何责任。\n          ")])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/api/agreement.000c0d674e2d1779546c.js